import {Component, Input, OnInit} from '@angular/core';
import {sprintf} from "sprintf-js";
import {BranchMathValve} from "./ValveMathStruct";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {VariableValue} from "../../../variableDataBase/VariableValue";


@Component({
  selector: 'app-branch-type-math-valve',
  templateUrl: './branch-type-math-valve.component.html',
  styleUrls: ['./branch-type-math-valve.component.css']
})
export class BranchTypeMathValveComponent implements OnInit {
  @Input() branchMathValve: BranchMathValve | undefined;
  volumeToDay: &VariableValue = new VariableValue();
  volumeYesterDay: &VariableValue = new VariableValue();
  valveStatus: &VariableValue = new VariableValue();

  constructor(private variableDB: VariableDataBase) {
  }

  GetValue(variable: VariableValue) : string
  {
    if(variable.IsInvalid())
        return "NaN";
    return sprintf("%5.1f", variable.val / 1);
  }

  ngOnInit(): void {
    if(this.branchMathValve) {
      this.volumeToDay     = this.variableDB.AddValueByReference(this.branchMathValve.volumetoday.variable.id);
      this.volumeYesterDay = this.variableDB.AddValueByReference(this.branchMathValve.volumeyesterday.variable.id);
      this.valveStatus     = this.variableDB.AddValueByReference(this.branchMathValve.valvestatus.variable.id);
    }
  }

}

